import { LEGACY_URL } from 'config'
import { RequestBuilder, authorizedPipe } from 'services/net'
import { ContentType } from 'shared'

const ENDPOINT_BULK_DELETE = `${LEGACY_URL}/v3/posts/delete_posts`

export const V1 = Object.freeze({
  // Delete multiple posts
  deletePosts(
    ids: string[],
    pageIds: string[],
    type: 'queued' | 'pending' | 'scheduled' | 'failed' | 'planned',
    all?: boolean,
    bucketId?: string,
    query?: string,
    types?: ContentType[],
    source?: 'bucket' | 'no-bucket'
  ) {
    const endpoint = ENDPOINT_BULK_DELETE
    const builder = new RequestBuilder(endpoint).asPost().expectJSON()
    const data: any = {
      type,
      pp_page_ids: pageIds
    }

    if (all) {
      data.selected = 'all'
    } else {
      data.post_ids = ids
    }

    if (bucketId) {
      data.type = type !== 'failed' ? 'planned_bucket' : type
      data.bucket_id = bucketId
    }

    if (query) {
      data.search = query
    }
    if (types) {
      data.post_types = types.join(',')
    }

    if (source) {
      data.source = source
    }

    return authorizedPipe<any>(
      builder
        .body(data)
        .build()
    )
  },
  restoreDeletedPosts(ids: string[]) {
    const builder = new RequestBuilder(`${LEGACY_URL}/v3/posts/restore`).asPost().expectJSON()
    return authorizedPipe<any>(
      builder
        .body({ ids })
        .build()
    )
  }
})
